import { useDispatch, useSelector } from 'react-redux';
import ConfirmationModal from 'app/components/post/ConfirmationModal';
import {
  openReportModal,
  openPostReviewModalForEdit,
  openLoginModal,
} from 'app/dispatcher/modalDispatcher';
import { deleteReview } from 'app/dispatcher/reviewDispatcher';
import { REPORT_MODAL, TYPES } from 'app/constants/report';
import noop from 'lodash/noop';
import get from 'lodash/get';

const useReviewMenu = ({ review, isPreview }) => {
  const dispatch = useDispatch();

  if (isPreview) return [];

  const isUserReview = get(review, 'createdByCurrentUser', false);
  const productId = get(review, 'product.id', '');
  const reviewId = get(review, 'id', '');

  const isSignedIn = useSelector(state => state.auth.session.isSignedIn);

  const ownOptions = [
    {
      title: 'Edit',
      value: 'edit',
      onClick: () =>
        dispatch(openPostReviewModalForEdit({ productId, review })),
    },
    {
      title: 'Delete',
      value: 'delete',
      onClick: () =>
        ConfirmationModal({
          title: 'Are you sure you want to delete review?',
          content: 'Review will be permanently removed.',
          okText: 'Confirm',
          cancelText: 'Cancel',
        }).then(() => dispatch(deleteReview({ reviewId })), noop),
    },
  ];

  const publicOptions = [
    {
      title: 'Report',
      value: 'report',
      onClick: () => {
        const modalData = {
          id: reviewId,
          data: REPORT_MODAL[TYPES.REVIEW],
          commentableType: null,
        };
        if (!isSignedIn) {
          sessionStorage.setItem('new-report', JSON.stringify(modalData));
          return dispatch(openLoginModal());
        }
        dispatch(openReportModal(modalData));
      },
    },
  ];

  return isUserReview ? ownOptions : publicOptions;
};

export default useReviewMenu;
